import styled from 'styled-components';

import media from '../../../styles/media.style';
import { BG_GRAY, TEXT_GRAY } from '../../../styles/variables.style';

export const HowToPanelWrapper = styled.div`
  max-width: 1060px;
  margin: 0 auto 20px;
  padding: 0 20px;
`;

export const Wrapper = styled.ul`
  max-width: 1060px;
  margin: 0 auto 20px;
  height: 308px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  > div {
    margin-right: 20px;
    width: 250px;
    height: 275px;
  }
  > li {
    font-size: 14px;
    margin-right: 25px;
    width: 250px;
    height: 308px;
    list-style-type: none;
    figcaption {
      margin-top: 10px;
    }
  }
`;

export const TitleWrapper = styled.div`
  color: ${TEXT_GRAY.COMMON_5};
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 3em;
  position: relative;
  text-align: center;
  text-transform: uppercase;

  &::after {
    content: '';
    position: absolute;
    bottom: -18px;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${BG_GRAY.COMMON_8};
    height: 3px;
    width: 40px;
  }

  ${media.tabletL`
    margin: 0 0 7em;
  `};
`;

export const ContentList = styled.div`
  ${media.tabletL`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 0 auto 20px;
  `};
`;
export const Content = styled.div`
  margin-bottom: 40px;
  > div {
    width: 100% !important;
    height: auto !important;
  }
  img {
    width: 100%;
  }
  p {
    font-size: 16px;
    margin-top: 20px;
  }
  ${media.tabletL`
    margin-right: 20px;
    img {
      width: 250px;
    }
    p {
      width: 250px;
    }
    &:last-child {
      margin-right: 0;
    }
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/RangePage/HowToPanel/HowToPanel.style.js